import React, { Dispatch, SetStateAction } from 'react';
import { Box, Checkbox, Flex, Image, Spinner, Text } from '@chakra-ui/react';

import { useAssetCardBodyByIdQuery } from 'features/hero/assets-tab/components/asset-card-body/queries.gen';
import { SelectedAssetsInfo } from 'widgets/create-card-modal/interfaces';

interface AssetCardBodyProps {
	assetId: string;
	setSelectedAssetsInfo?: Dispatch<SetStateAction<SelectedAssetsInfo>>;
	isActive?: boolean;
}

export const AssetCardBody: React.FC<AssetCardBodyProps> = ({
	assetId,
	setSelectedAssetsInfo,
	isActive,
}) => {
	const { data, loading } = useAssetCardBodyByIdQuery({
		variables: {
			id: assetId,
		},
	});

	const handleChange = () =>
		setSelectedAssetsInfo
			? setSelectedAssetsInfo((prev: SelectedAssetsInfo) => ({
					...prev,
					selectedBodies: isActive
						? prev.selectedBodies.filter((el) => el !== assetId)
						: [...prev.selectedBodies, assetId],
			  }))
			: null;

	return (
		<Flex flexDirection="column" gap={2} minW="240px" maxW="260px">
			<Box
				h="min-content"
				userSelect="none"
				border="4px solid transparent"
				borderRadius="10px"
				position="relative"
				// cursor="pointer"
				// borderColor={`${isSelected(assetId) ? 'rgba(100, 77, 237, 0.08)' : ''}`}
				// onClick={() => handleSelectAsset(assetId)}
			>
				<Flex
					height="300px"
					alignItems="center"
					justifyContent="center"
					border="1px solid #EEEEF2"
					borderRadius="10px"
					overflow="hidden"
					borderColor={isActive ? '#644DED' : ''}
					_hover={{
						borderColor: '#644DED',
						cursor: 'pointer',
					}}
				>
					{loading ? (
						<Spinner size="md" />
					) : (
						<Box
							position="relative"
							top="20%"
							transform="scale(0.9)"
							onClick={handleChange}
						>
							<Image alt={data?.body.name || ''} src={data?.body.link || ''} />
						</Box>
					)}
				</Flex>

				{!loading && (
					<Box position="absolute" top={1} right={1}>
						<Checkbox m="10px" isChecked={isActive} onChange={handleChange} />
					</Box>
				)}
			</Box>
			<Text p={1} fontSize="12px" fontWeight={600} lineHeight="16px">
				{data?.body.name || ''}
			</Text>
		</Flex>
	);
};
